import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import 'contents/assets/scss/page/student.scss';

function SatisfactionExternal() {
  const [modalOpen, setModalOpen] = useState(true);
  return (
    <main className="com_container">
      <Modal open={modalOpen} close={() => setModalOpen(false)} type="pop_satisfaction_external">
        <h2 className="pop_tit">고객 만족도 조사 </h2>
        <p className="pop_cont">
          안녕하세요. 홍길동 부모님. <br />더 나은 교육을 위해 학부모님의 수업 평가가 필요합니다.
        </p>
        <div className="content_container scroll">
          <table className="com_board_list type_row">
            <colgroup>
              <col width="60" />
              <col width="auto" />
            </colgroup>
            <tbody>
              <tr>
                <th className="th_center" rowSpan={2}>
                  1
                </th>
                <td>
                  <strong>수업에 만족 하셨나요?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">그렇다</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">그렇지 않다</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">그렇다</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">그렇지 않다</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th className="th_center" rowSpan={2}>
                  2
                </th>
                <td>
                  <strong>수업에 만족 하셨나요?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">그렇다</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">그렇지 않다</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">그렇다</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">그렇지 않다</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th className="th_center" rowSpan={2}>
                  3
                </th>
                <td>
                  <strong>수업에 만족 하셨나요?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">그렇다</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">그렇지 않다</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">그렇다</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">그렇지 않다</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th className="th_center" rowSpan={2}>
                  4
                </th>
                <td>
                  <strong>수업에 만족 하셨나요?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">그렇다</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">그렇지 않다</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">그렇다</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">그렇지 않다</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th className="th_center" rowSpan={2}>
                  5
                </th>
                <td>
                  <strong>수업에 만족 하셨나요?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">그렇다</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">그렇지 않다</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">그렇다</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">그렇지 않다</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th className="th_center" rowSpan={2}>
                  6
                </th>
                <td>
                  <strong>수업에 만족 하셨나요?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">그렇다</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">그렇지 않다</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">그렇다</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">그렇지 않다</label>
                  </div>
                </td>
              </tr>
              <tr>
                <th className="th_center" rowSpan={2}>
                  7
                </th>
                <td>
                  <strong>수업에 만족 하셨나요?</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="com_radio_wrap">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">그렇다</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">그렇지 않다</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">그렇다</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">그렇지 않다</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">등록</button>
        </div>
      </Modal>
    </main>
  );
}

export default SatisfactionExternal;
